/* eslint-disable import/prefer-default-export */
import { useEffect, useState } from 'react';
import { useStoreState } from 'easy-peasy';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import client from '../../../utils/apolloClient';

const placesQuery = gql`
  query searchPlaces($input: SearchInput) {
    search_places_from_view(input: $input) {
      place_listing {
        place_id
        display_order
        name
        address_line_1
        address_line_2
        city
        state
        country
        post_code
        status
        claim_status
      }
    }
  }
`;

export const getPlaces = input =>
  new Promise((resolve, reject) => {
    client.clientPrivate
      .query({
        query: placesQuery,
        variables: {
          input,
        },
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        console.log('data places', data);
        if (
          data &&
          data.search_places_from_view &&
          data.search_places_from_view.place_listing &&
          data.search_places_from_view.place_listing.length !== 0
        ) {
          resolve(data.search_places_from_view.place_listing);
        }
      })
      .catch(error => {
        reject(error);
      });
  });

const fetchPlaceQuery = gql`
  query fetchPlaceQuery($placeId: String!) {
    fetch_place(input: { place_id: $placeId }) {
      place_id
      name
      city
      state
      country
      post_code
      status
    }
  }
`;

export const usePlaceData = ({ placeId }) => {
  const {
    data: fetchPlaceData,
    loading: fetchPlaceLoading,
    error: fetchPlaceError,
  } = useQuery(fetchPlaceQuery, {
    variables: { placeId },
    client: client.clientPublic,
  });

  return [
    fetchPlaceLoading,
    fetchPlaceError,
    fetchPlaceData && fetchPlaceData.fetch_place
      ? fetchPlaceData.fetch_place
      : null,
  ];
};

export const chunkArray = (array, size) =>
  array.reduce((acc, val, idx) => {
    if (idx % size === 0) acc.push([]);
    acc[acc.length - 1].push(val);
    return acc;
  }, []);

const searchPlacesQuery = gql`
  query searchPlacesQuery($placeId: [String], $userId: String) {
    search_places(
      input: {
        user_id: $userId
        filter: { place_filter: { place_id: $placeId } }
      }
    ) {
      place_listing {
        state
        place_id
        name
        city
        post_code
        status
      }
    }
  }
`;

const fetchPlaces = async ({ placeId, userId }) => {
  try {
    const data = await client.clientPrivate.query({
      client: client.clientPrivate,
      query: searchPlacesQuery,
      variables: {
        placeId,
        userId,
      },
      fetchPolicy: 'network-only',
    });

    if (
      data?.data?.search_places?.place_listing &&
      Array.isArray(data?.data?.search_places?.place_listing)
    ) {
      return data?.data?.search_places?.place_listing;
    }
    return [];
  } catch {
    return [];
  }
};

export const usePlaceIds = ({ placeIds, refetchPlaceData }) => {
  const { userId } = useStoreState(state => state.auth);
  const [response, setResponse] = useState(new Map());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFunc = async () => {
      setLoading(true);
      setResponse(new Map());
      try {
        const prms = placeIds.map(ele => fetchPlaces({ placeId: ele, userId }));
        const results = await Promise.all(prms);

        const flattenedResults = results.flatMap(ele => ele);

        setResponse(prev => {
          const temp = new Map(prev);
          flattenedResults.forEach(ele2 => {
            temp.set(ele2.place_id, ele2);
          });
          return temp;
        });
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };

    if (placeIds.length === 0) {
      setLoading(false);
    } else {
      fetchFunc();
    }
  }, [refetchPlaceData]);

  return [loading, response];
};
